// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__cuVOd","left":"InfoRow_left__3rOXZ"};